// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"b875d223","703":"1b5e4d60","787":"8d293ecf"}[chunkId] + ".chunk.js";
};